module.exports = __webpack_public_path__ + "static/img/manual_zh_2.89b69ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_2.png
// module id = 0zbh
// module chunks = 4